'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002ecomponents$002e$002dMui$002dComponents$0024$002dMui$002dIcon from "./mealorama.components.-Mui-Components$-Mui-Icon.js";
var $p;
/** @constructor */
function $c_Lmealorama_components_MuiComponents$MuiIcon$$anon$17() {
  this.hO = null;
  $j_mealorama$002ecomponents$002e$002dMui$002dComponents$0024$002dMui$002dIcon.$ct_Lmealorama_components_MuiComponents$MuiIcon__T__(this, "open_in_new");
}
export { $c_Lmealorama_components_MuiComponents$MuiIcon$$anon$17 as $c_Lmealorama_components_MuiComponents$MuiIcon$$anon$17 };
$p = $c_Lmealorama_components_MuiComponents$MuiIcon$$anon$17.prototype = new $j_mealorama$002ecomponents$002e$002dMui$002dComponents$0024$002dMui$002dIcon.$h_Lmealorama_components_MuiComponents$MuiIcon();
$p.constructor = $c_Lmealorama_components_MuiComponents$MuiIcon$$anon$17;
/** @constructor */
function $h_Lmealorama_components_MuiComponents$MuiIcon$$anon$17() {
}
export { $h_Lmealorama_components_MuiComponents$MuiIcon$$anon$17 as $h_Lmealorama_components_MuiComponents$MuiIcon$$anon$17 };
$h_Lmealorama_components_MuiComponents$MuiIcon$$anon$17.prototype = $p;
$p.q = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.r = (function() {
  return "OpenInNew";
});
$p.m = (function() {
  return "OpenInNew";
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("OpenInNew");
});
var $d_Lmealorama_components_MuiComponents$MuiIcon$$anon$17 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_components_MuiComponents$MuiIcon$$anon$17, "mealorama.components.MuiComponents$MuiIcon$$anon$17", ({
  HI: 1,
  ag: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1,
  n: 1,
  d: 1,
  e: 1,
  h: 1
}));
export { $d_Lmealorama_components_MuiComponents$MuiIcon$$anon$17 as $d_Lmealorama_components_MuiComponents$MuiIcon$$anon$17 };
//# sourceMappingURL=mealorama.components.-Mui-Components$-Mui-Icon$$anon$17.js.map
